var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linked)?_c('button',{staticClass:"ebx-panel-toggle",class:( _obj = {}, _obj[("ebx-panel-toggle--id-" + _vm.panelId)] = true, _obj['ebx-panel-toggle--is-collapsed'] =  _vm.collapsed, _obj ),on:{"click":_vm.onClick}},[_c('span',{staticClass:"ebx-panel-toggle__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("ebx-panel-toggle-after")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }